import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const LegalPage = lazy(() => import('../pages/legal/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/mentions-legales',
    element: <LegalPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
